import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CommentsResourcesComponent } from './comments-resources.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoadingModule } from './../loading/loading.module';
import { CommentsResourcesService } from './comments-resources.service';
import { SafePipe } from './safe.pipe';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { reducers } from './ngrx/reducers';
import { CommentsResources } from './ngrx/effects';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

registerLocaleData(localeEs, 'es');

@NgModule({
  imports: [
    CommonModule,
    BrowserAnimationsModule,
    StoreModule.forFeature(CommentsResourcesService.featureName, reducers),
    EffectsModule.forFeature([CommentsResources]),
    FormsModule,
    LoadingModule
  ],
  exports: [
    CommentsResourcesComponent
      ],
  declarations: [CommentsResourcesComponent, SafePipe],
  providers: [
    CommentsResourcesService,

  ]
})
export class CommentsResourcesModule { }
